import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ProofOfAddressFormErrorStatesEnum {
    UploadFileFailed = ErrorStateScheduleEnum.ProofOfAddressFormStatesStartIndex,
    CreateDocumentFailed,
    UpdateDocumentFailed
}
